import Card from "../../../../ui/Card/Card";
import ProgressBar from "../../../../ui/ProgressBar/ProgressBar";
import Badge from "../../../../ui/Badge/Badge";
import { billingTierLabel } from "../../../../util/billing";
import styles from "./PlanCard.module.scss";
import { differenceInMonths, format } from "date-fns";
import Button from "../../../../ui/Button/Button";
import ChangePlanModal from "./ChangePlanModal/ChangePlanModal";
import { useDisclosure } from "../../../../ui/util/useDisclosure";
import useUser from "../../../../providers/UserProvider/useUser";
import Tooltip from "../../../../ui/Tooltip/Tooltip";

function PlanCardFooter() {
  const [changePlanModalOpened, changePlanModal] = useDisclosure();
  const { tenant } = useUser();

  return (
    <div className={styles.footer}>
      {tenant?.parentTenant ? (
        <Tooltip
          content={`Your billing is managed by ${tenant?.parentTenant?.name}. Changes to be billing must be made from the ${tenant?.parentTenant?.name} team.`}
        >
          <Button variant="outline" disabled>
            Change plan
          </Button>
        </Tooltip>
      ) : (
        <Button variant="outline" onClick={changePlanModal.open}>
          Change plan
        </Button>
      )}
      <ChangePlanModal
        isOpen={changePlanModalOpened}
        onClose={changePlanModal.close}
      />
    </div>
  );
}

function PlanCard() {
  const { billingInfo, usageForCurrentPeriod } = useUser();

  return (
    <Card className={styles.card}>
      <div className={styles.innerCard}>
        <div className={styles.container}>
          <div className={styles.header}>
            <div className={styles.tierDetails}>
              <div className={styles.tierName}>
                <span>
                  {`${
                    billingInfo && billingTierLabel[billingInfo.billingTier]
                  } Plan`}{" "}
                </span>
                {!!billingInfo?.articlesPerMonth && (
                  <Badge variant="badge" color="default" showDot={false}>
                    {differenceInMonths(
                      new Date(billingInfo.currentPeriodEnd),
                      new Date(billingInfo.currentPeriodStart),
                    ) > 1
                      ? "Yearly"
                      : "Monthly"}
                  </Badge>
                )}
              </div>
              {!!billingInfo?.articlesPerMonth && (
                <p className={styles.planReset}>
                  {`Usage resets monthly on the ${
                    billingInfo
                      ? format(new Date(billingInfo?.currentPeriodStart), "do")
                      : ""
                  }`}
                </p>
              )}
            </div>
            <span className={styles.price}>{`${Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }).format(
              billingInfo ? billingInfo.subscriptionPrice / 100 : 0,
            )}`}</span>
          </div>
          {!!billingInfo?.articlesPerMonth && (
            <div>
              <p
                className={styles.articlesUsed}
              >{`${usageForCurrentPeriod?.articles}/${billingInfo?.articlesPerMonth} Article credits`}</p>
              <ProgressBar
                currentValue={usageForCurrentPeriod?.articles ?? 0}
                maxValue={billingInfo?.articlesPerMonth ?? 1}
              />
            </div>
          )}
        </div>
        <PlanCardFooter />
      </div>
    </Card>
  );
}

export default PlanCard;
